import React from "react";
import { Row, Col } from "antd";
import Style from "./courseInfo.module.scss";
import { toFixedNumber } from "pages/homework/utils/filter";
import moment from "moment";
import { sectionDescribe } from "../../../../Utils/filter";

interface ICourseInfoProps {
    courseName: string;
    weekTime: string;
    section: string;
    continunity: string;
    score: string;
    quantity: number;
    date?: string;
    bg?: boolean;
}

const CourseInfo = ({
    courseName,
    weekTime,
    section,
    continunity,
    score,
    quantity,
    date,
    bg
}: ICourseInfoProps) => {
    return (
        <div className={`${bg ? Style.bg : ""} ${Style.main}`}>
            <Row className={Style.line}>
                <Col span={5}>课程：</Col>
                <Col span={19}>
                    <span>{courseName}</span>
                </Col>
            </Row>
            <Row className={Style.line}>
                <Col span={5}>周次：</Col>
                <Col span={6}>
                    <span>第{weekTime}周</span>
                </Col>
                <Col span={5}>节次：</Col>
                <Col span={8}>
                    <span>{sectionDescribe(section, continunity)}</span>
                </Col>
            </Row>
            <Row className={Style.line}>
                <Col span={5}>总分：</Col>
                <Col span={6}>
                    <span>{toFixedNumber(score)}</span>
                </Col>
                <Col span={5}>数量：</Col>
                <Col span={8}>
                    <span>{quantity}</span>
                </Col>
            </Row>
            {date && (
                <Row className={Style.line}>
                    <Col span={5}>截止：</Col>
                    <Col span={19}>
                        <span>
                            {moment(date).format("YYYY-MM-DD HH:mm:ss")}
                        </span>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default CourseInfo;
